module.exports = __webpack_public_path__ + "img/question-mark.aa0526bf.png";